export * from "./auth";
export * from "./data";
export * from "./balance";
export * from "./balance-sheet";
export * from "./indicator";
export * from "./dashboard";
export * from "./dashboardComposition";
export * from "./dashboardList";
export * from "./slideComposition";
export * from "./authorizations";
export * from "./annexe";
export * from "./annexeCategory";
export * from "./slideList";
export * from "./PreparePresentation";
export * from "./presentation";
export * from "./access-key";
export * from "./indicatorsExplanation";
export * from "./extraSlideList";
export * from "./collaborator";
export * from "./emailing";
export * from "./fiduciary";
export * from "./activity";
export * from "./notification";



// WEBPACK FOOTER //
// ./src/api/index.js